import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminGroupNewRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/groups/new',
}).lazy(() =>
  import('pages/admin/Groups/AdminGroupNewPage/AdminGroupNewPage').then((d) => d.Route)
);
